import { campaigns, ui, imagesBench } from 'api';
import {
  UI_GET_MASTER_DATA,
  UI_IMAGES_BENCH_MASTER_DATA,
  UI_GET_TOWNS_BY_CP,
  UI_UPDATE_TOWNS_BY_CP_CACHE,
  UI_UPDATE_MASTER_DATA,
  UI_SET_LOADER,
  UI_SET_SHOWROOM_TYPE,
  UI_SET_OPERATIONS_FILTER,
  UI_SET_EXPIRATIONS_FILTER,
  UI_SET_COMMON_FILTER,
  UI_RESET_COMMONS_FILTERS,
  UI_GET_SECTION_FILTERS,
  UI_SET_SECTION_FILTERS,
  GOTO_EXTERNAL_URL,
  UI_GET_CAMPAIGN_EDIT_FIELDS,
  UI_SET_CAMPAIGN_EDIT_FIELDS,
  UI_GET_SECTION_MENU,
  UI_SET_SECTION_MENU,
  UI_GET_VEHICLE_MARKS,
  UI_SET_VEHICLE_MARKS,
  UI_GET_VEHICLE_MODELS,
  UI_SET_VEHICLE_MODELS,
  UI_SET_VEHICLE_STYLE_BODY,
  UI_SET_VEHICLE_LOCATION,
  UI_GET_IMAGES_BENCH_VEHICLE_BRAND,
  UI_GET_IMAGES_BENCH_VEHICLE_MODELS,
  UI_GET_IMAGES_BENCH_VEHICLE_VERSION,
  UI_GET_VEHICLE_STYLE_BODY,
  UI_SET_VEHICLE_VERSION,
  UI_GET_IMAGES_BENCH_VEHICLE_OPTIONS,
  UI_SET_VEHICLE_OPTIONS,
  SHOW_MAIN_NOTIFICATION,
  CLEAR_MAIN_NOTIFICATION
} from 'store/actions/ui';

export default {
  [UI_GET_MASTER_DATA]: ({ commit, getters }) =>
    new Promise((resolve, reject) => {
      if (!getters.hasMasterData) {
        campaigns.getMasterData().then(
          resp => {
            commit(UI_UPDATE_MASTER_DATA, resp.data);
            resolve();
          },
          err => {
            commit('ERROR_OCCURRED', err, {
              root: true
            });
            reject();
          }
        );
      } else {
        resolve();
      }
    }),

  [UI_IMAGES_BENCH_MASTER_DATA]: ({ commit }) =>
    new Promise((resolve, reject) => {
      imagesBench.getMasterData().then(
        resp => {
          const data = resp.data;
          commit(UI_SET_VEHICLE_STYLE_BODY, {
            property: 'imagesBenchFilter.vehicleTypeOptions',
            vehiclesType: data.shellType,
            convert: false
          });
          commit(UI_SET_VEHICLE_LOCATION, {
            property: 'imagesBenchFilter.vehicleLocationOptions',
            locations: data.location
          });
          commit(UI_SET_VEHICLE_LOCATION, {
            property: 'tagsOptions',
            locations: data.tag
          });
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [UI_GET_TOWNS_BY_CP]: ({ state, commit }, cp) =>
    new Promise((resolve, reject) => {
      const townsCache = state.townsCache;
      const townsByCpCache = townsCache[cp];
      if (townsByCpCache !== undefined && townsByCpCache.length > 0) {
        return resolve(townsByCpCache);
      }
      campaigns.getTownsByCp(cp).then(
        resp => {
          const towns = resp.data;
          commit(UI_UPDATE_TOWNS_BY_CP_CACHE, {
            cp,
            towns
          });
          resolve(towns);
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [UI_SET_LOADER]: ({ commit }, loading) => {
    commit(UI_SET_LOADER, loading);
  },

  [UI_SET_SHOWROOM_TYPE]: ({ commit }, showRoomType) => {
    commit(UI_SET_SHOWROOM_TYPE, showRoomType);
  },

  [UI_SET_OPERATIONS_FILTER]: ({ commit }, { filter, value }) => {
    commit(UI_SET_OPERATIONS_FILTER, {
      filter,
      value
    });
  },

  [UI_SET_EXPIRATIONS_FILTER]: ({ commit }, { filter, value }) => {
    commit(UI_SET_EXPIRATIONS_FILTER, {
      filter,
      value
    });
  },
  [UI_SET_COMMON_FILTER]: ({ commit }, { filter, value }) => {
    commit(UI_SET_COMMON_FILTER, {
      filter,
      value
    });
  },
  [UI_RESET_COMMONS_FILTERS]: ({ commit }) => {
    commit(UI_RESET_COMMONS_FILTERS);
  },

  [UI_GET_SECTION_FILTERS]: ({ commit }, { entity, perPage = 200, sortDesc = true }) =>
    new Promise((resolve, reject) => {
      ui.getSectionDataByEntity(entity).then(
        resp => {
          resp.data.fields.forEach(item => {
            // eslint-disable-next-line no-param-reassign
            item.selected = item.default ? item.default : null;
          });
          commit(UI_SET_SECTION_FILTERS, {
            sectionFilters: resp.data,
            entity,
            perPage,
            sortDesc
          });
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [UI_GET_CAMPAIGN_EDIT_FIELDS]: ({ commit }, entity) =>
    new Promise((resolve, reject) => {
      ui.getSectionDataByEntity(entity).then(
        resp => {
          const data = resp.data;
          commit(UI_SET_CAMPAIGN_EDIT_FIELDS, data);
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [UI_GET_SECTION_MENU]: ({ commit }, entity) =>
    new Promise((resolve, reject) => {
      ui.getSectionDataByEntity(entity).then(
        resp => {
          const items = resp.data.menu;
          commit(UI_SET_SECTION_MENU, items);
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [GOTO_EXTERNAL_URL]: (param, url) => {
    window.open(url);
  },

  [UI_GET_VEHICLE_MARKS]: ({ commit }, { saveIn }) =>
    new Promise((resolve, reject) => {
      ui.getBrands().then(
        resp => {
          const brands = resp.data;
          commit(UI_SET_VEHICLE_MARKS, { property: saveIn, brands });
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [UI_GET_VEHICLE_MODELS]: ({ commit }, { saveIn, brand }) =>
    new Promise((resolve, reject) => {
      ui.getModelByBrand(brand).then(
        resp => {
          const models = resp.data;
          commit(UI_SET_VEHICLE_MODELS, { property: saveIn, models });
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [UI_GET_VEHICLE_STYLE_BODY]: ({ commit }, { saveIn, brand }) =>
    new Promise((resolve, reject) => {
      ui.getVehicleTypeByBrand(brand).then(
        resp => {
          const vehiclesType = resp.data;
          commit(UI_SET_VEHICLE_STYLE_BODY, { property: saveIn, vehiclesType });
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [UI_GET_IMAGES_BENCH_VEHICLE_BRAND]: ({ commit }, { saveIn, filters }) =>
    new Promise((resolve, reject) => {
      ui.getImagesBenchBrands(filters).then(
        resp => {
          const brands = resp.data;
          commit(UI_SET_VEHICLE_MARKS, { property: saveIn, brands, convert: false });
          resolve();
        },
        err => {
          reject(err.response.data);
        }
      );
    }),

  [UI_GET_IMAGES_BENCH_VEHICLE_MODELS]: ({ commit }, { saveIn, filters }) =>
    new Promise((resolve, reject) => {
      ui.getImagesBenchModel(filters).then(
        resp => {
          const models = resp.data;
          commit(UI_SET_VEHICLE_MODELS, { property: saveIn, models, convert: false });
          resolve();
        },
        err => {
          reject(err.response.data);
        }
      );
    }),

  [UI_GET_IMAGES_BENCH_VEHICLE_VERSION]: ({ commit }, { saveIn, filters }) =>
    new Promise((resolve, reject) => {
      ui.getImagesBenchVersion(filters).then(
        resp => {
          const versions = resp.data;
          commit(UI_SET_VEHICLE_VERSION, { property: saveIn, versions });
          resolve();
        },
        err => {
          reject(err.response.data);
        }
      );
    }),

  [UI_GET_IMAGES_BENCH_VEHICLE_OPTIONS]: ({ commit }, { saveIn, filters }) =>
    new Promise((resolve, reject) => {
      ui.getImagesBenchVehicle(filters).then(
        resp => {
          const vehicle = resp.data;
          commit(UI_SET_VEHICLE_OPTIONS, { property: saveIn, vehicle });
          resolve();
        },
        err => {
          reject(err.response.data);
        }
      );
    }),

  [SHOW_MAIN_NOTIFICATION]: ({ state, commit }, { variant, time, message }) => {
    commit(SHOW_MAIN_NOTIFICATION, { variant, time, message });
    const delay = ((time || state.mainNotification.time || 5) + 1) * 1000;
    setTimeout(() => {
      commit(CLEAR_MAIN_NOTIFICATION);
    }, delay);
  }
};
